import { useEffect } from 'react';

import Button from 'components/partials/button/button';
import { useImpersonation } from 'hooks/use-impersonation';
import { findUser } from 'hooks/api/use-users';

const ImpersonationBanner = () => {
  const { isImpersonating, impersonatingUser, impersonate, stopImpersonating } =
    useImpersonation();

  useEffect(() => {
    const impersonatingInfo = isImpersonating();

    if (impersonatingInfo && !impersonatingUser) {
      const impersonatingId = impersonatingInfo.id;

      const savedRedirectTo = impersonatingInfo.redirectTo;

      findUser(impersonatingId as string | number).then((user) => {
        impersonate(user.data, savedRedirectTo as string, { skipRedirect: true });
      });
    }
  }, []);

  if (!impersonatingUser) return null;

  const client = impersonatingUser.client as { name?: string; label?: string } | undefined;

  return (
    <div
      className="flex bg-navy-500 px-8 justify-center items-center h-12 text-white"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center">
        <p className="mr-2 text-sm">Viewing as:</p>
        <p
          className="font-bold text-sm mr-4"
          data-testid="impersonation-banner-client-name"
        >
          {client?.name || client?.label}
        </p>
        <Button
          variant="reserve-filled"
          className="bg-gray-700 hover:bg-gray-600 border-gray-700"
          size="sm"
          onClick={() => stopImpersonating()}
          data-testid="impersonation-banner-exit-preview"
        >
          Exit preview
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
